// Italiano.
export default {
    'canvas.title': 'Contenuto della pagina',
    'canvas.loading': 'Caricamento dell’editor…',
    'empty.title': 'Inizia la tua pagina',
    'empty.text': 'Trascina qui un blocco o una sezione pronta, oppure fai clic per aggiungerla.',
    'empty.sections': 'Vedi le sezioni',
    'empty.blocks': 'Aggiungi un blocco',

    'panel.insert': 'Aggiungi',
    'panel.settings': 'Impostazioni',
    'panel.content': 'Contenuto',
    'panel.layout': 'Layout',
    'panel.style': 'Stile',
    'panel.visibility': 'Visibilità',
    'panel.advanced': 'Avanzate',
    'tab.blocks': 'Blocchi',
    'tab.sections': 'Sezioni',
    'tab.layers': 'Livelli',
    'category.layout': 'Layout',
    'category.basic': 'Base',
    'category.media': 'Media',
    'category.components': 'Componenti',
    'category.advanced': 'Avanzate',
    'palette.hint': 'Trascina nella pagina o fai clic per aggiungere',
    'palette.none': 'Nessun blocco corrisponde alla ricerca.',
    'sections.intro': 'Trascina una sezione nella pagina o fai clic per aggiungerla. Tutto resta modificabile.',
    'layers.empty': 'La pagina è vuota.',
    'inspector.empty': 'Seleziona un blocco della pagina per modificarne contenuto e stile.',
    'inspector.path': 'Posizione nella pagina',

    'device.label': 'Dimensione dell’anteprima',
    'device.desktop': 'Computer',
    'device.tablet': 'Tablet',
    'device.mobile': 'Telefono',

    'action.undo': 'Annulla',
    'action.redo': 'Ripristina',
    'action.guides': 'Mostra i contorni dei blocchi',
    'action.preview': 'Anteprima',
    'action.code': 'Modifica il codice',
    'action.copyCode': 'Copia il codice',
    'action.fullscreen': 'Schermo intero',
    'action.selectParent': 'Seleziona il blocco genitore',
    'action.move': 'Trascina per spostare',
    'action.moveUp': 'Sposta su',
    'action.moveDown': 'Sposta giù',
    'action.duplicate': 'Duplica',
    'action.remove': 'Elimina',
    'action.close': 'Chiudi',
    'action.apply': 'Applica',
    'action.cancel': 'Annulla',
    'action.clear': 'Cancella',
    'action.search': 'Cerca',
    'action.searchBlocks': 'Cerca un blocco…',
    'action.addColumn': 'Aggiungi una colonna',
    'action.equalize': 'Larghezze uguali',
    'action.addButton': 'Aggiungi un pulsante',
    'action.addItem': 'Aggiungi un elemento',
    'action.resizeColumns': 'Trascina per ridimensionare le colonne',
    'category.saved': 'Salvati',
    'action.saveBlock': 'Salva come blocco riutilizzabile',
    'action.save': 'Salva',
    'action.restore': 'Ripristina',
    'saved.name': 'Nome del blocco',
    'saved.help': 'Il blocco e tutto ciò che contiene saranno proposti in Blocchi › Salvati, per questa pagina e le prossime.',
    'saved.done': 'Blocco salvato: lo trovi in Blocchi › Salvati.',
    'saved.remove': 'Rimuovi questo blocco salvato',
    'notice.draftFound': 'Le modifiche del {date} non sono state salvate.',
    'error.storage': 'Il browser non ha potuto conservare questo blocco (memoria piena o disattivata).',

    'shortcut.undo': 'annulla',
    'shortcut.duplicate': 'duplica',
    'shortcut.move': 'sposta su o giù',
    'shortcut.remove': 'elimina',
    'shortcut.parent': 'seleziona il genitore',
    'shortcut.edit': 'modifica il testo',

    'block.container': 'Contenitore',
    'block.containerFluid': 'Larghezza piena',
    'block.box': 'Riquadro',
    'block.row': 'Riga',
    'block.col': 'Colonna',
    'block.heading': 'Titolo',
    'block.text': 'Testo',
    'block.quote': 'Citazione',
    'block.list': 'Elenco',
    'block.table': 'Tabella',
    'block.button': 'Pulsante',
    'block.separator': 'Separatore',
    'block.spacer': 'Spazio',
    'block.icon': 'Icona',
    'block.html': 'HTML',
    'block.image': 'Immagine',
    'block.video': 'Video',
    'block.embed': 'Pagina incorporata',
    'block.map': 'Mappa',
    'block.card': 'Scheda',
    'block.accordion': 'Fisarmonica',
    'preset.cols1': '1 colonna',
    'preset.cols2': '2 colonne',
    'preset.cols3': '3 colonne',
    'preset.cols4': '4 colonne',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 colonne',

    'placeholder.heading': 'Il tuo titolo',
    'placeholder.text': 'Scrivi qui il tuo testo. Seleziona delle parole per metterle in grassetto, in corsivo o come link.',
    'placeholder.quote': 'Una bella citazione, breve e memorabile.',
    'placeholder.author': 'Nome dell’autore',
    'placeholder.item': 'Elemento',
    'placeholder.column': 'Colonna',
    'placeholder.button': 'Clicca qui',
    'placeholder.readMore': 'Leggi di più',
    'placeholder.caption': 'Didascalia dell’immagine',
    'placeholder.cardTitle': 'Titolo della scheda',
    'placeholder.cardText': 'Una breve descrizione che invita a saperne di più.',
    'placeholder.question': 'Domanda',
    'placeholder.answer': 'La risposta, in poche frasi chiare.',
    'placeholder.html': 'Il tuo codice HTML',
    'placeholder.address': 'Torre Eiffel, Parigi',

    'field.width': 'Larghezza',
    'field.tag': 'Tag HTML',
    'field.gutters': 'Spazio tra le colonne',
    'field.justify': 'Allineamento orizzontale',
    'field.alignItems': 'Allineamento verticale',
    'field.alignSelf': 'Allineamento verticale nella riga',
    'field.columnWidth': 'Larghezza per dimensione dello schermo',
    'field.level': 'Livello',
    'field.size': 'Dimensione',
    'field.thickness': 'Spessore',
    'field.opacity': 'Opacità',
    'field.height': 'Altezza',
    'field.icon': 'Icona',
    'field.filled': 'Piena',
    'field.image': 'Immagine',
    'field.alt': 'Testo alternativo',
    'field.link': 'Link',
    'field.newTab': 'Apri in una nuova scheda',
    'field.caption': 'Didascalia',
    'field.align': 'Allineamento',
    'field.ratio': 'Proporzioni',
    'field.corners': 'Angoli',
    'field.shadow': 'Ombra',
    'field.videoUrl': 'Video',
    'field.controls': 'Mostra i controlli',
    'field.autoplay': 'Riproduzione automatica (senza audio)',
    'field.loop': 'In loop',
    'field.muted': 'Senza audio',
    'field.url': 'Indirizzo (URL)',
    'field.address': 'Indirizzo',
    'field.zoom': 'Zoom',
    'field.showImage': 'Mostra un’immagine',
    'field.titleLevel': 'Livello del titolo',
    'field.showButton': 'Mostra un pulsante',
    'field.firstOpen': 'Primo elemento aperto',
    'field.items': 'Elementi',
    'field.question': 'Domanda',
    'field.text': 'Testo',
    'field.style': 'Stile',
    'field.code': 'Codice HTML',
    'field.textAlign': 'Allineamento del testo',
    'field.spacing': 'Spaziature',
    'field.margin': 'Margine esterno',
    'field.padding': 'Margine interno',
    'field.background': 'Sfondo',
    'field.backgroundImage': 'Immagine di sfondo',
    'field.textColor': 'Colore del testo',
    'field.border': 'Bordo',
    'field.showOn': 'Mostra su',
    'field.id': 'Ancora (ID)',
    'field.classes': 'Classi CSS',
    'field.inlineStyle': 'Stile in linea',
    'side.t': 'in alto',
    'side.b': 'in basso',
    'side.s': 'a sinistra',
    'side.e': 'a destra',

    'help.alt': 'Descrive l’immagine a chi non può vederla e ai motori di ricerca.',
    'help.video': 'Un link YouTube o Vimeo, oppure l’indirizzo di un file MP4.',
    'help.embed': 'L’indirizzo di una pagina che accetta di essere incorporata (un modulo, un calendario…).',
    'help.columnWidth': 'Prima il telefono: una dimensione vuota usa quella dello schermo più piccolo, mostrata in grigio.',
    'help.visibility': 'Togli la spunta a una dimensione per nascondere il blocco su quegli schermi.',
    'help.id': 'Permette a un link di puntare a questo blocco: #ancora.',
    'help.classes': 'Classi del tuo tema o di Bootstrap, separate da spazi.',
    'help.accordion': 'Fai clic su una domanda o una risposta nella pagina per modificarne il testo.',
    'help.html': 'Gli script e gli attributi di evento vengono rimossi per sicurezza.',

    'option.default': 'Predefinito',
    'option.none': 'Nessuno',
    'option.auto': 'Auto',
    'option.fill': 'Riempi',
    'option.inherit': 'Eredita',
    'option.custom': 'Colore personalizzato',
    'option.boxed': 'Centrato',
    'option.fullWidth': 'Larghezza piena',
    'option.start': 'Sinistra',
    'option.center': 'Centro',
    'option.end': 'Destra',
    'option.between': 'Distribuito',
    'option.top': 'In alto',
    'option.middle': 'Al centro',
    'option.bottom': 'In basso',
    'option.wrapLeft': 'A sinistra, testo intorno',
    'option.wrapRight': 'A destra, testo intorno',
    'option.original': 'Originale',
    'option.square': 'Squadrati',
    'option.rounded': 'Arrotondati',
    'option.pill': 'Pillola',
    'option.circle': 'Cerchio',
    'option.small': 'Piccola',
    'option.medium': 'Media',
    'option.large': 'Grande',
    'button.primary': 'Principale',
    'button.outline-primary': 'Principale, contorno',
    'button.secondary': 'Secondario',
    'button.outline-secondary': 'Secondario, contorno',
    'button.success': 'Successo',
    'button.outline-success': 'Successo, contorno',
    'button.danger': 'Pericolo',
    'button.outline-danger': 'Pericolo, contorno',
    'button.warning': 'Avviso',
    'button.outline-warning': 'Avviso, contorno',
    'button.info': 'Info',
    'button.outline-info': 'Info, contorno',
    'button.light': 'Chiaro',
    'button.outline-light': 'Chiaro, contorno',
    'button.dark': 'Scuro',
    'button.outline-dark': 'Scuro, contorno',
    'button.link': 'Link',

    'rte.toolbar': 'Formattazione del testo',
    'rte.format': 'Stile del paragrafo',
    'rte.paragraph': 'Paragrafo',
    'rte.lead': 'Sommario',
    'rte.small': 'Testo piccolo',
    'rte.table': 'Tabella…',
    'rte.rowAbove': 'Inserisci una riga sopra',
    'rte.rowBelow': 'Inserisci una riga sotto',
    'rte.colLeft': 'Inserisci una colonna a sinistra',
    'rte.colRight': 'Inserisci una colonna a destra',
    'rte.deleteRow': 'Elimina la riga',
    'rte.deleteCol': 'Elimina la colonna',
    'rte.deleteTable': 'Elimina la tabella',
    'rte.heading': 'Titolo {n}',
    'rte.quote': 'Citazione',
    'rte.code': 'Codice',
    'rte.bold': 'Grassetto (Ctrl+B)',
    'rte.italic': 'Corsivo (Ctrl+I)',
    'rte.underline': 'Sottolineato (Ctrl+U)',
    'rte.strike': 'Barrato',
    'rte.link': 'Link (Ctrl+K)',
    'rte.unlink': 'Rimuovi il link',
    'rte.bulletList': 'Elenco puntato',
    'rte.numberedList': 'Elenco numerato',
    'rte.alignLeft': 'Allinea a sinistra',
    'rte.alignCenter': 'Centra',
    'rte.alignRight': 'Allinea a destra',
    'rte.justify': 'Giustifica',
    'rte.clear': 'Cancella la formattazione',

    'media.upload': 'Carica',
    'media.library': 'Scegli',
    'media.urlOnly': 'Incolla l’indirizzo del file. Inviare file dal computer richiede un indirizzo di caricamento (opzione uploadUrl).',
    'media.embedded': 'Immagine salvata nella pagina',

    'code.title': 'Codice HTML della pagina',
    'code.help': 'Modifica il codice e applicalo: PageFlow ritrova i suoi blocchi. Gli script vengono rimossi.',

    'notice.copied': 'Codice copiato negli appunti',
    'notice.noGrid': 'Gli stili del sito non sono stati caricati nell’editor: nel frattempo si usa una griglia semplice. Controlla l’opzione canvasStyles.',
    'notice.codeApplied': 'Codice applicato',
    'notice.cannotInsert': 'Questo blocco non può andare qui. Seleziona prima una colonna o un contenitore.',
    'error.copy': 'Impossibile copiare il codice. Selezionalo nella vista del codice.',
    'error.fileType': 'Questo tipo di file non è accettato qui.',
    'error.fileSize': 'Questo file è troppo grande (massimo {size} MB).',
    'error.upload': 'Impossibile caricare il file.',
    'error.noUpload': 'Nessun indirizzo di caricamento impostato: i file del computer non possono essere inviati. Incolla invece l’indirizzo del file (sviluppatori: opzione uploadUrl, gestore PHP incluso).',

    'sec.heroSplit': 'Hero con immagine',
    'sec.heroSplitDesc': 'Titolo, testo e pulsanti accanto a una foto.',
    'sec.heroCenter': 'Hero centrato',
    'sec.heroCenterDesc': 'Un grande messaggio centrato su una fascia chiara.',
    'sec.features': 'Punti di forza',
    'sec.featuresDesc': 'Tre punti di forza con icone.',
    'sec.imageText': 'Immagine e testo',
    'sec.imageTextDesc': 'Una foto accanto a un testo e a un elenco.',
    'sec.cta': 'Invito all’azione',
    'sec.ctaDesc': 'Una fascia colorata con un pulsante chiaro.',
    'sec.cards': 'Schede',
    'sec.cardsDesc': 'Tre articoli, prodotti o servizi.',
    'sec.testimonials': 'Testimonianze',
    'sec.testimonialsDesc': 'Cosa dicono di te i tuoi clienti.',
    'sec.pricing': 'Prezzi',
    'sec.pricingDesc': 'Tre piani affiancati.',
    'sec.faq': 'FAQ',
    'sec.faqDesc': 'Domande e risposte che si aprono con un clic.',
    'sec.stats': 'Cifre chiave',
    'sec.statsDesc': 'Quattro numeri che ispirano fiducia.',
    'sec.team': 'Team',
    'sec.teamDesc': 'Ritratti con nomi e ruoli.',
    'sec.contact': 'Contatti',
    'sec.contactDesc': 'Indirizzo, telefono ed e-mail accanto a una mappa.',
    'sec.gallery': 'Galleria',
    'sec.galleryDesc': 'Sei foto in griglia.',
    'sec.heroTitle': 'Crea belle pagine in pochi minuti',
    'sec.heroText': 'Trascina, rilascia e scrivi: la tua pagina è pronta, adatta ai telefoni e pulita, senza una sola riga di codice.',
    'sec.getStarted': 'Inizia ora',
    'sec.learnMore': 'Scopri di più',
    'sec.contactUs': 'Contattaci',
    'sec.imageAlt': 'Foto',
    'sec.centerTitle': 'Tutto ciò che serve, niente di troppo',
    'sec.centerText': 'Una promessa semplice che dice ai visitatori che sono nel posto giusto.',
    'sec.featuresTitle': 'Perché sceglierci',
    'sec.featuresText': 'Tre buoni motivi, in poche parole.',
    'sec.feature1': 'Veloce',
    'sec.feature2': 'Affidabile',
    'sec.feature3': 'Pensato per i telefoni',
    'sec.featureText': 'Descrivi questo punto di forza in una o due frasi che parlino ai tuoi visitatori.',
    'sec.imageTextTitle': 'Racconta la tua storia',
    'sec.imageTextText': 'Spiega cosa fai e come aiuti, con le parole dei tuoi clienti.',
    'sec.point1': 'Un primo vantaggio',
    'sec.point2': 'Un secondo vantaggio',
    'sec.point3': 'Un terzo vantaggio',
    'sec.ctaTitle': 'Pronto a iniziare?',
    'sec.ctaText': 'Unisciti a chi ci ha già scelto. Basta un minuto.',
    'sec.cardsTitle': 'Ultime notizie',
    'sec.cardTitle': 'Un titolo di scheda',
    'sec.cardText': 'Un breve riassunto che invoglia a continuare a leggere.',
    'sec.readMore': 'Leggi di più',
    'sec.testimonialsTitle': 'Cosa dicono i nostri clienti',
    'sec.quote1': 'Semplice, veloce e bello. Abbiamo rifatto tutto il sito in un fine settimana.',
    'sec.quote2': 'L’assistenza ha risposto entro un’ora. Lo consiglio senza esitazione.',
    'sec.quote3': 'Con le nuove pagine i visitatori restano più a lungo e ci contattano più spesso.',
    'sec.name1': 'Emma Lawson',
    'sec.name2': 'Luca Martini',
    'sec.name3': 'Sofia Rossi',
    'sec.role1': 'Fondatrice, Studio Nord',
    'sec.role2': 'Responsabile, Porto Blu',
    'sec.role3': 'Direttrice, Atelier Verde',
    'sec.pricingTitle': 'Prezzi semplici',
    'sec.pricingText': 'Nessun costo nascosto. Cambia o disdici quando vuoi.',
    'sec.plan1': 'Base',
    'sec.plan2': 'Professionale',
    'sec.plan3': 'Business',
    'sec.month': 'mese',
    'sec.benefit1': 'Un primo vantaggio',
    'sec.benefit2': 'Un secondo vantaggio',
    'sec.benefit3': 'Un terzo vantaggio',
    'sec.choose': 'Scegli questo piano',
    'sec.faqTitle': 'Domande frequenti',
    'sec.question1': 'Come inizio?',
    'sec.answer1': 'Scegli un piano, crea il tuo account e segui la guida: bastano pochi minuti.',
    'sec.question2': 'Posso cambiare piano più tardi?',
    'sec.answer2': 'Sì, in qualsiasi momento. La differenza viene calcolata per te.',
    'sec.question3': 'Offrite assistenza?',
    'sec.answer3': 'Il nostro team risponde via e-mail ogni giorno lavorativo.',
    'sec.question4': 'I miei dati sono al sicuro?',
    'sec.answer4': 'I tuoi dati sono conservati in modo sicuro e mai condivisi.',
    'sec.stat1': 'clienti soddisfatti',
    'sec.stat2': 'di soddisfazione',
    'sec.stat3': 'assistenza',
    'sec.stat4': 'paesi',
    'sec.teamTitle': 'Il team',
    'sec.member': 'Membro del team',
    'sec.jobTitle': 'Ruolo',
    'sec.contactTitle': 'Contattaci',
    'sec.contactText': 'Saremo felici di sentirti. Scrivici o vieni a trovarci.',
    'sec.addressLabel': 'Indirizzo',
    'sec.address': '5 Avenue Anatole France, 75007 Parigi',
    'sec.phoneLabel': 'Telefono',
    'sec.emailLabel': 'E-mail',
    'sec.galleryTitle': 'Galleria',
};
